import React, { createContext, useContext, useState, useEffect } from "react";
import axiosInstance from "../api/api.js";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [role, setRole] = useState(null);
  const [id, setId] = useState(null);

  const [loading, setLoading] = useState(true); // NEW

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const storedRole = localStorage.getItem("role");
    const storedId = localStorage.getItem("user_id");

    if (storedToken && storedRole && storedId) {
      setIsAuthenticated(true);
      setRole(storedRole);
      setId(storedId);
    }

    setLoading(false); // Set loading to false after checking storage
  }, []);

  const login = async (email, password) => {
    try {
      const response = await axiosInstance.post("/auth/login", {
        email,
        password,
      });

      const { token, user } = response.data || {};
      if (!token || !user || !user.role || !user.id) {
        console.error("Missing fields in login response");
        return { success: false, error: "Invalid login response structure" };
      }
      const role = user.role;
      const userId = user.id; // ✅ FIXED: Use user.id instead of user._id

      // console.log("Extracted values:", { token: !!token, role, userId });
      // Store token and user info in localStorage, matching the API client.
      if (!token || !role || !userId) {
        console.error("Missing token, role, or userId in login response");
        return { success: false, error: "Invalid login response" };
      }

      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("user_id", userId);

      setIsAuthenticated(true);
      setRole(role);
      setId(userId);

      return { success: true, role };
    } catch (error) {
      console.error("Login failed:", error.response?.data || error.message);
      return {
        success: false,
        error: error.response?.data?.error || "Login failed",
      };
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("user_id");
    setIsAuthenticated(false);
    setRole(null);
    setId(null);
  };

  useEffect(() => {
    const handleUnauthorized = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("user_id");
      setIsAuthenticated(false);
      setRole(null);
      setId(null);
    };
    window.addEventListener("clock:unauthorized", handleUnauthorized);
    return () => window.removeEventListener("clock:unauthorized", handleUnauthorized);
  }, []);

return (
  <AuthContext.Provider value={{ isAuthenticated, role, id, login, logout, loading }}>
    {children}
  </AuthContext.Provider>
);

};

export const useAuth = () => useContext(AuthContext);
